import { toggleClass } from '@studiometa/js-toolkit/utils';
import { Panel } from '@studiometa/ui';

/**
 * StorePanel component
 */
export default class StorePanel extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'StorePanel',
  };

  /**
   * open
   * @param {object} data
   * @param {string} data.title
   * @param {string} data.url
   * @param {string} data.address
   * @param {string} data.icon
   * @param {string} data.img
   * @param {string} data.phone
   * @param {string} data.website
   * @param {string} data.email
   * @param {string} data.lat
   * @param {string} data.lng
   * @param {string} data.description
   * @param {string} data.opening
   */
  setData({ title, url, address, icon, img, phone, website, email, lat, lng, description, opening }) {
    const titleEl = this.$el.querySelector('#store-title');
    titleEl.innerHTML = title;
    titleEl.href = url;

    this.$el.querySelector('#store-address').innerHTML = address;

    const image = this.$el.querySelector('#store-image');
    toggleClass(image, 'hidden', typeof img === 'undefined' || img.length === 0);
    image.src = img;
    console.log(img);

    const phoneContainer = this.$el.querySelector('#store-phone-container');
    toggleClass(phoneContainer, 'hidden', typeof phone === 'undefined' || phone.length === 0);
    const phoneEl = this.$el.querySelector('#store-phone');
    phoneEl.innerHTML = phone;
    phoneEl.href = `tel:${phone.split(' ').join('')}`;

    const emailContainer = this.$el.querySelector('#store-email-container');
    toggleClass(emailContainer, 'hidden', typeof email === 'undefined' || email.length === 0);
    const emailEl = this.$el.querySelector('#store-email');
    emailEl.innerHTML = email;
    emailEl.href = `mailto:${email}`;

    const websiteContainer = this.$el.querySelector('#store-website-container');
    toggleClass(websiteContainer, 'hidden', typeof website === 'undefined' || website.length === 0);
    const websiteEl = this.$el.querySelector('#store-website');
    websiteEl.innerHTML = website;
    websiteEl.href = website;

    const storeMaps = this.$el.querySelector('#store-maps');
    storeMaps.href = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

    const descriptionContainer = this.$el.querySelector('#store-description-container');
    toggleClass(
      descriptionContainer,
      'hidden',
      typeof description === 'undefined' || description.length === 0,
    );

    const descriptionEl = this.$el.querySelector('#store-description');
    descriptionEl.innerHTML = description;

    const openingContainer = this.$el.querySelector('#store-opening-container');
    toggleClass(
      openingContainer,
      'hidden',
      typeof opening === 'undefined' || opening.length === 0,
    );

    const openingEl = this.$el.querySelector('#store-opening');
    openingEl.innerHTML = opening;
  }
}
